import PropTypes from 'prop-types';
import React from 'react';
import BaseComponent from "../../gd-components/base-component/base-component";
import ModalV4Header from "../../../app/ui/modal/v4/header/v4-header";

const propTypes = {
    onClick: PropTypes.func.isRequired,
    onClickBack: PropTypes.func.isRequired,
};

class CreateNoAccess extends BaseComponent {

    constructor(props) {
        super(props);

        this._bind('closeModal');
    }

    closeModal(e) {
        e.stopPropagation();
        gd.modal.hide();
    }

    render() {
        const { onClickBack, onClick } = this.props;

        return (
            <div className="v4-container placement-middle add-no-access" onClick={onClick}>

                <ModalV4Header height={60} title="New Status" onClose={this.closeModal} onGoBack={onClickBack} />

                <div className="warning-message">
                    <div className="warning-title">403. No Access.</div>
                    <div className="warning-content">
                        Organization role <strong>Manager</strong> is required to perform this action.
                    </div>
                </div>
            </div>
        );
    }
}

CreateNoAccess.propTypes = propTypes;

module.exports = CreateNoAccess;